<script lang="ts">
    import { PRODUCT_VARIANT_DEFAULT_TITLE } from "@/constants";
    import { urlsBuilderContextToken } from "@/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import ProductEntity from "@modules/products/entities/ProductEntity";

    import Image from "@components/Image/Image.svelte";

    import MainProductFrame from "./SingleProductFrame.svelte";

    export let product: ProductEntity;
    export let productUrl: string;

    const urlsBuilder = getTypedContext(urlsBuilderContextToken);
</script>

<MainProductFrame>
    <svelte:fragment slot="image">
        {#if product.featuredImage}
            <Image
                src={urlsBuilder.createProductImageUrl(
                    product.featuredImage.url
                )}
                imgClassName="gw-rv-product-image"
                alt="productImage"
                objectFit="cover"
            />
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="title">
        <a href={productUrl}>{product.title}</a>
    </svelte:fragment>

    <svelte:fragment slot="vendor">
        {#if product.variants[0].title !== PRODUCT_VARIANT_DEFAULT_TITLE}
            {product.variants[0].title}
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="price">
        {product.variants[0].price.amount +
            " " +
            product.variants[0].price.currency}
    </svelte:fragment>
</MainProductFrame>

<style>
    :global(.gw-rv-product-image) {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
